import React from "react";
import "./FunctionGridItem.css";

const FunctionGridItem = ({ red, children, data, image }) => {
  return (
    <div className="functions_grid_item">
      <div
        className={
          red
            ? "icon_container icon_container_red"
            : "icon_container icon_container_blue"
        }
      >
        <img src={image} alt="laptop_image" className="laptop_image" />
      </div>
      <div
        className="functions_grid_text"
        dangerouslySetInnerHTML={{ __html: data }}
      >
        {children}
      </div>
    </div>
  );
};

export default FunctionGridItem;
